export type ReportPermissions = {
    IsPostFiltering: boolean;
    IsStudent: boolean;
    PickerPermission: boolean;
    ReportFeatureFlag: boolean;
}

export enum EResourceType {
    Assessment = 0, // Test / Quiz
    Question = 1,
    Text = 2,
    Video = 3, // Video, H5P Video
    DocumentsAndFiles = 4, // Excel, PDF, PowerPoint, Word, Zip
    LinksAndExternalContent = 5 // LTI, Resource Link Request, Web Content
}